<template>
  <div>
    <v-checkbox
      v-model="value.is_max_request_count"
      :label="`Уведомлять пользователя если превышен лимит запросов в сутки`"
      dense
    ></v-checkbox>
  </div>
</template>

<script>
import RadarNotification from "../../../models/radars/RadarNotification";

export default {
  name: "radar-notifications",
  props: {
    value: {
      type: Object,
      default: function() {
        return new RadarNotification();
      }
    }
  }
};
</script>